import UserGroupTransfer from './user-group-transfer.vue'
UserGroupTransfer.install = function (Vue) {
  Vue.component(UserGroupTransfer.name, UserGroupTransfer);
};
export default UserGroupTransfer



// WEBPACK FOOTER //
// ./src/omnis-business/user-group-transfer/index.js